module.exports = __webpack_public_path__ + "static/img/login_weixin.8ca7919.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/common/icons/login_weixin.png
// module id = 79
// module chunks = 2 3 4 6 7